import init_idb from './init_idb'

const DB_NAME = 'ckb';
const DB_VERSION = 117; // Use a long long for this value (don't use a float)
const DB_STORE_NAME = 'done_forms';

function openIndexedDB () {
  // This works on all devices/browsers, and uses IndexedDBShim as a final fallback 
  var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

  var openDB = indexedDB.open(DB_NAME, DB_VERSION);

  openDB.onsuccess = function(event) {
    // store the result of opening the database in the db variable.
    db = openDB.result
    console.log("Database opened.")
    console.log(`Database version: ${db.version}`)
  
    // add listener to handle the database version change
    db.onversionchange = function() {
      console.log("Database is outdated, please reload the page.")
  
      //!important when version change is detected close the database immediately
      db.close()
      // instruct the user to reload the page via popup
      // and block any interaction with the site
      // launchPopup($newVersionPopupContent)
      alert("Database is outdated, please reload the page.")
      window.location.reload()
    }
  }

  /*openDB.onupgradeneeded = function(event) {
    var db = {}
    db.result = openDB.result;
    if (!Array.from(db.result.objectStoreNames).includes(DB_STORE_NAME)){
      // db.thisStore = db.result.createObjectStore("solutions", { keyPath: "id", autoIncrement: true });
      db.thisStore = db.result.createObjectStore(DB_STORE_NAME, { keyPath: "done_at" });
      // db.store = db.result.createObjectStore("custom_fields", { keyPath: "id" });
    } else {
      db.tx = event.target.transaction
      db.thisStore = db.tx.objectStore(DB_STORE_NAME);
    }
    if (!db.thisStore.indexNames.contains("done_at")) {
      db.thisStore.createIndex('done_at', 'done_at', { unique: false });
    }
  };*/

  openDB.onupgradeneeded = function(event) {
    init_idb(event)
  };

  openDB.onerror = function(error){
    console.log("Erro open db: ", error)
  }

  return openDB;
}

function getStoreIndexedDB (openDB, mode) {
  var db = {};
  db.result = openDB.result;
  db.tx = db.result.transaction(DB_STORE_NAME, mode);
  db.thisStore = db.tx.objectStore(DB_STORE_NAME);

  return db;
}


export default{
  store_done_form(done_form){


    var openDB = openIndexedDB();

    openDB.onsuccess = function() {
      var db = getStoreIndexedDB(openDB, 'readwrite');
      let done_at = done_form.done_at;
      var addRequest = db.thisStore.add({done_form, done_at});
      addRequest.onsuccess = function(){
           // auto-comment// console.log("Done form armazenado")

      }
      addRequest.onerror = function(error){
           // auto-comment// console.log("idb Erro ao tentar armazenar as solutions", error)
        // resolve(false)
      }
      
    }
  },
  get_all_done_form(){
    return new Promise(resolve => {
      var pending_done_forms = [];

      var openDB = openIndexedDB();
  
      openDB.onsuccess = function() {
        var db = getStoreIndexedDB(openDB, 'readonly');
  
        db.thisStore.openCursor().onsuccess = function(event) {
          var cursor = event.target.result;
          if (cursor) {
            pending_done_forms.push(cursor.value.done_form);
            cursor.continue();
          }else{
               // auto-comment// console.log("estas sao as pendencias salvas: ", pending_done_forms)
            resolve(pending_done_forms)
          }
        };
        
      }      
      
    })
  },
  remove_pending_done_form(key){
    var openDB = openIndexedDB();
  
    openDB.onsuccess = function() {
      var db = getStoreIndexedDB(openDB, 'readwrite');

      var deleteRequest = db.thisStore.delete(key);

      deleteRequest.onsuccess = function() {
           // auto-comment// console.log("pendencia de envio removida do idb");
        // resolve(true)
      }
      deleteRequest.onerror = function(error){
           // auto-comment// console.log("nao foi possível remover pendencia de envio do idb", error)
        // resolve(false)
      }
    }
  }
}
